import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  advancePayment: "/vales",
};

export const fetchAdvancePayment = createAsyncThunk(
  "advancePayment/fetchAdvancePayment",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.advancePayment, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createAdvancePayment = createAsyncThunk(
  "advancePayment/createAdvancePayment",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.advancePayment, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateAdvancePayment = createAsyncThunk(
  "advancePayment/updateAdvancePayment",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.advancePayment}/${data.slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteAdvancePayment = createAsyncThunk(
  "advancePayment/deleteAdvancePayment",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.advancePayment}/${slug}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const discountVouchers = createAsyncThunk(
  "advancePayment/discountVouchers",
  async (
    params: {
      userId: number;
      startDate: string;
      endDate: string;
      paid_at: string;
      payment_method_id: string;
      establishment_id?: number;
    },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.advancePayment}/discount`,
        params,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        console.error("Detalhes do erro:", error.response?.data);
        return thunkAPI.rejectWithValue({
          error:
            (error.response?.data && (error.response.data as any).message) ||
            (error as any).message,
          details: error.response?.data,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
